module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Geschmacksache")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Von Mickie B. Ashling")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Buch 2 in der Serie – Horizonte")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Was als kurzes Intermezzo gedacht war, wird zu etwas Tieferem, als Lil Lampert beim Taste of Chicago Grier Dilorio kennenlernt. Lil ist in der Stadt, um seine guten Freunde Jody Williams und Clark Stevens zu besuchen, aber er hatte nicht vor, einen jüngeren Mann kennenzulernen und die gemeinsame Liebe zur Architektur, Innenarchitektur und einem einzigartigen Fetisch zu finden, der Lil nicht loslässt.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Nach außen hin ist Grier ein Bad Boy, der die Geschwindigkeit, Tätowierungen und Leder liebt, aber Lil entdeckt langsam noch eine andere Seite an ihm: Er ist selbstlos, verantwortungsbewusst und zärtlich, besonders zu Luca, dem Sohn, den er verleugnen muss. Mit Lils Liebe und Unterstützung trifft Grier eine Entscheidung, die die Tür zu einer gemeinsamen Zukunft öffnet, die auch Vaterschaft einschließt. Etwas, von dem Lil immer geträumt hat, aber nie zu hoffen wagte.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfa55f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0002.vue
// module id = 60
// module chunks = 0